export function parseMonthDay(dateStr) {
    if (!dateStr || !dateStr.trim()) return null;
    const s = dateStr.trim();

    // Try YYYY-MM-DD (ISO)
    let parts = s.split('-');
    if (parts.length === 3 && parts[0].length === 4) {
        const m = parseInt(parts[1], 10);
        const d = parseInt(parts[2], 10);
        if (!isNaN(m) && !isNaN(d) && m >= 1 && m <= 12 && d >= 1 && d <= 31) {
            return { month: m, day: d };
        }
    }

    // Try MM/DD/YYYY or M/D/YYYY
    parts = s.split('/');
    if (parts.length === 3) {
        const m = parseInt(parts[0], 10);
        const d = parseInt(parts[1], 10);
        if (!isNaN(m) && !isNaN(d) && m >= 1 && m <= 12 && d >= 1 && d <= 31) {
            return { month: m, day: d };
        }
    }

    // Fallback: try Date.parse
    const parsed = new Date(s);
    if (!isNaN(parsed.getTime())) {
        return { month: parsed.getMonth() + 1, day: parsed.getDate() };
    }

    return null;
}

export function daysUntil(month, day) {
    const now = new Date();
    const thisYear = now.getFullYear();
    let next = new Date(thisYear, month - 1, day);
    const today = new Date(thisYear, now.getMonth(), now.getDate());
    if (next < today) {
        next = new Date(thisYear + 1, month - 1, day);
    }
    return Math.round((next - today) / (1000 * 60 * 60 * 24));
}
